<button
    *ngIf="!miniCover"
    kzButton buttonStyle="default"
    [buttonContext]="pro.isBoxable ? 'box' : 'decorator'"
    (click.appAccessControl)="!!$event && toggleFavorite()" class="pro-favorite"
    [class.active]="favoriteId"
    [class.pro-favorite--small]="size == 'small'"
>
    <span>
      <kz-icons name="like"></kz-icons>
      <span class="pro-favorite__label">
          <ng-container *ngIf="!favoriteId" i18n="@@pro.favorite.add">Add to favorite</ng-container>
          <ng-container *ngIf="favoriteId" i18n="@@pro.favorite.remove">Remove to favorite</ng-container>
      </span>
    </span>
</button>
